import React from 'react';
import ExpenseAndAmount from "./ExpenseAndAmount";
import CardResume from './CardResume';
import ExpenseByTruck from './ExpenseByTruck';
import RankingCategoryExpense from './RankingCategoryExpense';
import FuelByDriver from './FuelByDriver';

export default React.memo(({ dashboardData }) => {
    return (
        <>
            <CardResume trucks={dashboardData.trucks || []} data={dashboardData} />
            <ExpenseByTruck trucks={dashboardData.trucks || []}  />
            <ExpenseAndAmount
                amount={dashboardData?.amountTravels || 0}
                expense={dashboardData?.amountExpenses || 0}
            />

            <RankingCategoryExpense categories={dashboardData.categories} suppliers={dashboardData.suppliers}/>

            <FuelByDriver
                fuelConsumptionByDriver={dashboardData.fuelConsumptionByDriver || []}
            />
        </>
    )
});
